module.exports = __webpack_public_path__ + "img/sjtj_3.7f58ed21.svg";